export default __webpack_public_path__ + "static/media/jGBP.dedaaf19.png";